import React, { useContext, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Icon } from "@iconify/react";
import { useForm } from "react-hook-form";
import { signUpAPI } from "../APIs/API";
import { MyContext } from "../MyContext/MyProvider";

const Signup = () => {
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [showCPassword, setShowCPassword] = useState(false);
  const { setIsLoading } = useContext(MyContext);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const toggleCPasswordVisibility = () => {
    setShowCPassword(!showCPassword);
  };

  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm();

  const validatePasswordMatch = (value) => {
    return value === watch("password") || "Passwords do not match";
  };
  const filterAlphabets = (event) => {
    event.target.value = event.target.value.replace(/[^A-Za-z]/g, '');
  };
  
  const onSubmit = async (data) => {
    setIsLoading(true);
    const { terms, confirm_password, ...rest } = data;
    try {
      const res = await signUpAPI(rest);
      res && navigate("/login");
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <div className="login-main-container h-center v-center">
        <div className="login-container w-100 signup-container">
          <div className="input-form-main w-100">
            <h3 className="text-medium-black fw-semibold large text-center text-sm-start">
              Sign Up
            </h3>
            <form
              className="input-form h-center flex-column"
              onSubmit={handleSubmit(onSubmit)}
            >
              {/* <div className="name-div mt-50 d-flex space-between gap-4"> */}
              <div className="h-center mt-50 flex-column gap-12 w-100">
  <label className="large fw-normal text-medium-black">
    First Name
  </label>
  <input
    {...register("firstname", {
      required: "First name is required",
      maxLength: {
        value: 20,
        message: "Must not be more than 20 characters",
      },
    })}
    inputMode="text"
    type="text"
    className="signup-input"
    placeholder="Enter your First Name"
    onInput={filterAlphabets}
  />
  {errors.firstname && (
    <span className="error">{errors.firstname.message}</span>
  )}
</div>

<div className="h-center flex-column gap-12 w-100 mt-4">
  <label className="large fw-normal text-medium-black">
    Last Name
  </label>
  <input
    {...register("lastname", {
      required: "Last name is required",
      maxLength: {
        value: 20,
        message: "Must not be more than 20 characters",
      },
    })}
    inputMode="text"
    type="text"
    className="signup-input"
    placeholder="Enter your Last Name"
    onInput={filterAlphabets}
  />
  {errors.lastname && (
    <span className="error">{errors.lastname.message}</span>
  )}
</div>

              {/* </div> */}
              {/* <div className="email-phone-div mt-24 d-flex space-between gap-4"> */}
              <div className="h-center flex-column gap-12 w-100 mt-4">
                <label className="large fw-normal text-medium-black">
                  Email
                </label>
                <input
                  {...register("email", {
                    required: "Email is required",
                    maxLength: {
                      value: 30,
                      message: "Must not be more than 30 characters",
                    },
                    pattern: {
                      value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+.[a-zA-Z]{2,4}$/,
                      message: "Invalid email address",
                    },
                  })}
                  inputMode="email"
                  type="email"
                  className="signup-input"
                  placeholder="abc@gmail.com"
                />
                {errors.email && (
                  <span className="error">{errors.email.message}</span>
                )}
              </div>
              <div className="h-center flex-column gap-12 w-100 mt-4">
                <label className="large fw-normal text-medium-black">
                  Phone No.
                </label>
                <input
                  {...register("contact_number", {
                    required: "Phone number is required",
                    maxLength: {
                      value: 20,
                      message: "Must not be more than 20 characters",
                    },
                    pattern: {
                      value: /^[0-9]+$/,
                      message: "Invalid phone number, must only be digits",
                    },
                  })}
                  inputMode="numeric"
                  type="tel"
                  className="signup-input"
                  placeholder="Enter your Phone No."
                  onInput={(e) => {
                    e.target.value = e.target.value.replace(/[^0-9]/g, "");
                  }}
                />
                {errors.contact_number && (
                  <span className="error">{errors.contact_number.message}</span>
                )}
              </div>
              {/* </div> */}
              <div className="pswd d-flex flex-column gap-12 mt-24">
                <label className="large fw-normal text-medium-black">
                  Password
                </label>
                <div className="input-password">
                  <input
                    {...register("password", {
                      required: "Password is required",
                      minLength: {
                        value: 10,
                        message: "Must be at least 10 characters long",
                      },
                      pattern: {
                        value: /^(?=.*[A-Z])(?=.*[!@#$%^&*])(?=.*[0-9]).{8,}$/,
                        message:
                          "Must contain at least one uppercase letter, one special character, and one digit",
                      },
                    })}
                    inputMode="text"
                    type={showPassword ? "text" : "password"}
                    className="signup-input pswd-feild"
                    placeholder="*****"
                  />
                  <Icon
                    icon={showPassword ? "fa-solid:eye" : "fa6-solid:eye-slash"}
                    className="eye-icon"
                    onClick={togglePasswordVisibility}
                    color="#000000"
                  />
                </div>
                {errors.password && (
                  <span className="error">{errors.password.message}</span>
                )}
              </div>
              <div className="confirmpswd d-flex flex-column gap-12 mt-24">
                <label className="large fw-normal text-medium-black">
                  Confirm Password
                </label>
                <div className="input-password">
                  <input
                    {...register("confirm_password", {
                      required: "Please confirm your password",
                      validate: validatePasswordMatch,
                    })}
                    inputMode="text"
                    type={showCPassword ? "text" : "password"}
                    className="signup-input pswd-feild"
                    placeholder="*****"
                  />
                  <Icon
                    icon={
                      showCPassword ? "fa-solid:eye" : "fa6-solid:eye-slash"
                    }
                    className="eye-icon"
                    onClick={toggleCPasswordVisibility}
                    color="#000000"
                  />
                </div>
                {errors.confirm_password && (
                  <span className="error">
                    {errors.confirm_password.message}
                  </span>
                )}
              </div>
              <div className="terms-condition-div text-dark-black fw-normal d-flex space-between">
                <div className="check-me-div v-center gap-2">
                  <input
                    type="checkbox"
                    id="customCheckboxSelectAll"
                    style={{ display: "none" }}
                    {...register("terms", {
                      required: "You must agree to the terms",
                    })}
                  />
                  <label
                    htmlFor="customCheckboxSelectAll"
                    className="customCheckboxLabel"
                  >
                    <span
                      className="customCheckboxTick"
                      style={{
                        background: watch("terms") ? "#435AB8 " : "transparent",
                      }}
                    >
                      {watch("terms") && (
                        <span>
                          <Icon
                            icon="tabler:check"
                            width={20}
                            height={18}
                            color="#FFFFFF"
                          />
                        </span>
                      )}
                    </span>
                  </label>
                  <label className="small v-center gap-1 fw-normal">
                    {" "}
                    I agree to all the{" "}
                    <label className="text-red link">Terms</label>
                    and
                    <label className="text-red link">Privacy Policies</label>
                  </label>
                </div>
                {errors.terms && (
                  <span className="error">{errors.terms.message}</span>
                )}
              </div>
              <div className="bottom-btn-div mt-5">
                <button className="btn-primary" type="submit">
                  Create account
                </button>
                <div className="mt-3">
                  <label className="small fw-normal h-center v-center gap-1 text-black">
                    Already have an account?
                    <Link to="/login">
                      <label className="text-red link">Login</label>
                    </Link>
                  </label>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default Signup;
